"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButtonGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const repeat_js_1 = require("lit/directives/repeat.js");
const button_styles_1 = require("@/components/common/button/button.styles");
const roving_focus_controller_1 = require("@/controllers/roving-focus-controller");
const single_selection_controller_1 = require("@/controllers/single-selection-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/icon/icon");
// 누름 상태를 토글하는 버튼 묶음이므로 role="group" 컨테이너에 각 버튼은 aria-pressed로 표현한다.
// mm-toggle-button을 감싸 토큰으로 re-skin하지 않고, 공유 버튼 스타일 모듈(buttonBaseStyles·
// buttonSelectedStyles)을 조합해 자체 button을 렌더한다. 그래야 roving focus가 한 renderRoot의
// button을 바로 순회하고, 단일 선택 규칙도 shadow 경계 없이 그룹이 온전히 소유한다.
let ToggleButtonGroup = class ToggleButtonGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.value = '';
        this.stretch = false;
        // 아이콘만 보일 때 label을 보이는 텍스트 대신 버튼의 접근성 이름으로 쓴다.
        this.hiddenLabel = false;
        this.orientation = 'horizontal';
        this.selection = new single_selection_controller_1.SingleSelectionController({
            getValue: () => this.value,
            setValue: value => {
                this.value = value;
            },
        });
        this.rovingFocus = new roving_focus_controller_1.RovingFocusController(this, {
            getItems: () => Array.from(this.buttons),
            orientation: () => this.orientation,
            getActiveIndex: () => this.options.findIndex(option => this.selection.isOptionSelected(option)),
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'group');
    }
    render() {
        return (0, lit_1.html) `
      ${(0, repeat_js_1.repeat)(this.options, option => option.value, option => this.renderOption(option))}
    `;
    }
    renderOption(option) {
        return (0, lit_1.html) `
      <button
        type="button"
        aria-pressed=${this.selection.isOptionSelected(option) ? 'true' : 'false'}
        aria-label=${this.hiddenLabel ? option.label : lit_1.nothing}
        ?disabled=${option.disabled}
        @click=${() => this.handleOptionClick(option)}
      >
        ${this.renderIcon(option.icon)}${this.hiddenLabel ? lit_1.nothing : option.label}
      </button>
    `;
    }
    renderIcon(icon) {
        if (!icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${icon}></mm-icon>
    `;
    }
    handleOptionClick(option) {
        if (option.disabled)
            return;
        this.selection.select(option);
        (0, utils_1.emit)(this, 'change', { value: this.value });
    }
};
ToggleButtonGroup.styles = [
    shared_styles_1.resetStyles,
    button_styles_1.buttonBaseStyles,
    button_styles_1.buttonSelectedStyles,
    (0, lit_1.css) `
      :host {
        display: inline-flex;
        align-items: center;
      }

      button {
        --button-border-radius: 0;
      }

      button:first-child {
        --button-border-radius: var(--radius) 0 0 var(--radius);
      }

      button:last-child {
        --button-border-radius: 0 var(--radius) var(--radius) 0;
      }

      button:only-child {
        --button-border-radius: var(--radius);
      }

      :host([stretch]) {
        display: flex;
      }

      :host([stretch]) button {
        flex: 1;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ToggleButtonGroup.prototype, "options", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ToggleButtonGroup.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], ToggleButtonGroup.prototype, "stretch", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'hidden-label' })
], ToggleButtonGroup.prototype, "hiddenLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ToggleButtonGroup.prototype, "orientation", void 0);
__decorate([
    (0, decorators_js_1.queryAll)('button')
], ToggleButtonGroup.prototype, "buttons", void 0);
ToggleButtonGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-toggle-button-group')
], ToggleButtonGroup);
exports.ToggleButtonGroup = ToggleButtonGroup;
//# sourceMappingURL=data:application/json;base64,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